import {isInMainLanguage} from "@/consts/lanuages.js";

export function getValueOfMuiltLanguagesJson(value){
  var res
  if(isMuiltLanguagesJson(value)){
    if(value.hasOwnProperty(mm.store.state.currentLanguage)){
      res = value[mm.store.state.currentLanguage]
    }else{
      res = value.default
    }
  }else{
    res = value
  }

  return res
}

export function setValueOfMuiltLanguagesJson(value, languageId, val){
  if(!isMuiltLanguagesJson(value)){
    value = createMuiltLanguagesJson(value)
  }

  if(isInMainLanguage(languageId)){
    value['default'] = val
  }else{
    value[languageId] = val
  }


  return value
}


export function isMuiltLanguagesJson(value){
  var res = false
  if(value && value.hasOwnProperty('muiltLanguagesJson')){
    res = true
  }
  return res
}


export function createMuiltLanguagesJson(value){
  return {
    muiltLanguagesJson: true,
    'default': value
  }
}
